import {
	lazy,
} from 'react'

export const ClubDetailPageAsync = lazy(async() => {
	return import('./club-detail.page')
})
